import React, { FC } from "react"
import { RouteComponentProps } from "@reach/router"
import _ from "lodash"
import toggles from 'feature-toggles'
import Subnav from "components/subnav"
import { Container_s, Content_s } from "styles/app-styles"

interface Route {
  hard?: boolean,
  name: string,
  link: string
}

const RentRoll: FC<RouteComponentProps> = (props) => {
  let rentRollRoute = toggles.displayNewRentRoll() ? {name: 'Rent Roll', link: '/n/rent-roll/home'} : {name: 'Rent Roll', link: "/rent-roll/home", hard: true}
  let marketLeaseRoute = toggles.displayNewMarketLease() ? {name: 'Market Lease', link: '/n/rent-roll/market-lease'} : {name: 'Market Lease', link: "/rent-roll/market-lease", hard: true}
  let recoveryGroupRoute = toggles.displayNewTenantMarket() ? {name: 'Recovery Groups', link: "/n/rent-roll/recovery-groups"} : {name: 'Recovery Groups', link: "/rent-roll/recovery-groups", hard: true}
  let tenantGroupRoute = toggles.displayNewTenantMarket() ? {name: 'Tenant Groups', link: "/n/rent-roll/tenant-groups"} : {name: 'Tenant Groups', link: "/rent-roll/tenant-groups", hard: true}
  let namedRecoveriesRoute = toggles.displayNewNamedRecoveries() ? {name: 'Named Recoveries', link: "/n/rent-roll/named-recoveries"} : {name: 'Named Recoveries', link: "/rent-roll/named-recoveries", hard: true}

  let tabs: Route[] = [
    rentRollRoute,
    marketLeaseRoute,
    namedRecoveriesRoute,
    recoveryGroupRoute,
    tenantGroupRoute,
  ]

  return (
    <Container_s>
      <Subnav section="RENT ROLL" tabs={tabs}/>
      <div style={{paddingTop: '72px'}}>
        {props.children}
      </div>
    </Container_s>
  )
}

export default RentRoll
